import useTranslation from "../../hooks/useTranslation";
import { SurveyRecipient } from "../../types/survey";
import { Typography } from "../ui/Typography/Typography";
import { IconTypes } from "../ui/icons";
import { Icon } from "../ui/icons/Icon";
import "./SurveyRecipientList.scss";

export interface SurveyRecipientListProps {
  recipientList: SurveyRecipient[];
  setRecipientList: (recipients: SurveyRecipient[]) => void;
}
export const SurveyRecipientList = ({
  recipientList,
  setRecipientList,
}: SurveyRecipientListProps) => {
  const { t } = useTranslation("surveyLaunchPage");

  const handleDelete = (item: SurveyRecipient) => {
    const updatedItem = recipientList.filter((i) => i.email !== item.email);
    setRecipientList(updatedItem);
  };

  return (
    <div className="SurveyRecipientList">
      <Typography
        className="SurveyRecipientList__title"
        tagVariant="h3"
        desktop="body1"
        weight="bold"
      >
        {t("shareLink.recipients")}
      </Typography>
      <div className="SurveyRecipientList__list">
        {recipientList.map((item) => (
          <div className="SurveyRecipientList__list__item" key={item.email}>
            <div>{`${item.email}`}</div>
            {item.phone_number && <div>({item.phone_number})</div>}
            <button
              type="button"
              className="button"
              onClick={() => handleDelete(item)}
            >
              <Icon type={IconTypes.Close} size={14} />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};
